module.exports = __webpack_public_path__ + "static/media/CL.e5bb4615.png";